import React from 'react';
import CMSPageLayout from '../../components/CMSPageLayout';

const PolicyAndPrivacy: React.FC = () => {
  return <CMSPageLayout contentName="POLICY_AND_PRIVACY_PAGE_TYPEID" />;
};

export { PolicyAndPrivacy };
